import { confirm } from './alert.web';

/** Web twin of confirm-destructive: the styled WebAlertHost dialog. */
export interface ConfirmDestructiveOptions {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
}

export function confirmDestructive(
  options: ConfirmDestructiveOptions,
): Promise<boolean> {
  return confirm({
    ...options,
    destructive: true,
  });
}
